(function () {
  'use strict';

  var loaderScript = document.getElementById('amd-loader');
  var configUrl = loaderScript.getAttribute('data-config');
  var bundle = loaderScript.getAttribute('data-bundle');
  var loadController = function loadController() {
    var controllerOptions = {};
    var controllerPath = loaderScript.getAttribute('data-controller');
    var params = loaderScript.getAttribute('data-params');
    try {
      controllerOptions = JSON.parse(params);
    } catch (err) {
      controllerOptions = {};
    }
    window.require([controllerPath], function (controller) {
      var startController = function startController() {
        if (!window.started) {
          window.started = true;
          controller.start(controllerOptions);
        }
      };
      document.addEventListener('readystatechange', startController, false);
      if (document.readyState === 'complete') {
        startController();
      }
    });
  };
  window.require([configUrl], function () {
    if (!window.loadBundles) {
      window.loaded = {};
      window.loadBundles = function loadBundles(bundles) {
        bundles = bundles || [];
        bundles = bundles.concat(window.bundles);
        bundles = bundles.filter(function (item, index) {
          return item && bundles.indexOf(item) === index && window.loaded[item] !== true;
        });
        require(bundles, function () {
          bundles.forEach(function (item) {
            window.loaded[item] = true;
          });
          loadController();
        });
      };
    }
    if (bundle || window.bundles && window.bundles.length) {
      window.loadBundles([bundle]);
    } else {
      loadController();
    }
  });
})();
define("loader/bootstrap", function(){});

